import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { EmptyStatePanel } from '@/components/common/EmptyStatePanel';

const getLineTone = (line) => {
  if (line.startsWith('+') && !line.startsWith('+++')) return 'bg-emerald-500/15 text-emerald-200';
  if (line.startsWith('-') && !line.startsWith('---')) return 'bg-rose-500/15 text-rose-200';
  return 'text-slate-300';
};

export const AIEngineeringDiffPanel = ({ task }) => {
  const proposal = task?.suggest_fix_result;

  if (!task?.patch_diff) {
    return <EmptyStatePanel title="Proposta de correcção indisponível" description="Execute o Suggest Fix Real para visualizar o patch_diff persistido da task seleccionada." ctaLabel={null} testId="ai-engineering-empty-diff" />;
  }

  return (
    <Card className="border-slate-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold text-slate-900">Suggest Fix Real / Diff proposto</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {proposal ? (
          <div className="grid gap-3 md:grid-cols-2" data-testid="ai-engineering-suggest-fix-summary-box">
            <div className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-sm">
              <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Summary da proposta</p>
              <p className="mt-2 text-slate-900">{proposal.proposal_summary}</p>
            </div>
            <div className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-sm">
              <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Root cause refinada</p>
              <p className="mt-2 text-slate-900">{proposal.refined_root_cause}</p>
            </div>
            <div className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-sm">
              <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Risco da correcção</p>
              <p className="mt-2 text-slate-900">{proposal.risk_level?.value} — {proposal.risk_level?.reason}</p>
            </div>
            <div className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-sm">
              <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Confiança</p>
              <p className="mt-2 text-slate-900">{proposal.confidence?.label} ({proposal.confidence?.score}) — {proposal.confidence?.reason}</p>
            </div>
          </div>
        ) : null}

        {proposal?.affected_files?.length ? (
          <div className="rounded-sm border border-slate-200 p-3 text-sm" data-testid="ai-engineering-suggest-fix-affected-files-box">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Ficheiros potencialmente afectados</p>
            <div className="mt-3 space-y-2">
              {proposal.affected_files.map((item) => (
                <div key={`${task.id}-${item.path}`} className="rounded-sm border border-slate-200 bg-slate-50 p-2">
                  <p className="font-medium text-slate-900">{item.path}</p>
                  <p className="text-xs text-slate-500">{item.reason}</p>
                </div>
              ))}
            </div>
          </div>
        ) : null}

        <ScrollArea className="h-[320px] rounded-sm border border-slate-900 bg-slate-950" data-testid="ai-engineering-diff-panel">
          <pre className="p-4 text-xs leading-6" style={{ fontFamily: "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace" }}>
            {task.patch_diff.split('\n').map((line, index) => (
              <div key={`${task.id}-diff-${index}`} className={`rounded-sm px-2 ${getLineTone(line)}`}>{line || ' '}</div>
            ))}
          </pre>
        </ScrollArea>

        {proposal?.recommended_tests?.length ? (
          <div className="grid gap-3 md:grid-cols-2">
            <div className="rounded-sm border border-slate-200 p-3 text-sm" data-testid="ai-engineering-suggest-fix-tests-box">
              <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Próximos testes recomendados</p>
              <ul className="mt-3 list-disc space-y-2 pl-5 text-slate-900">
                {proposal.recommended_tests.map((item) => (<li key={item}>{item}</li>))}
              </ul>
            </div>

            <div className="rounded-sm border border-slate-200 p-3 text-sm" data-testid="ai-engineering-suggest-fix-changes-box">
              <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Suggested changes</p>
              <ul className="mt-3 list-disc space-y-2 pl-5 text-slate-900">
                {(proposal.suggested_changes || []).map((item) => (<li key={item}>{item}</li>))}
              </ul>
            </div>
          </div>
        ) : null}

        {proposal?.limits?.length ? (
          <div className="rounded-sm border border-slate-200 p-3 text-sm" data-testid="ai-engineering-suggest-fix-limits-box">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Limites da proposta</p>
            <ul className="mt-3 list-disc space-y-2 pl-5 text-slate-900">
              {proposal.limits.map((item) => (<li key={item}>{item}</li>))}
            </ul>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
};